import React, { useState } from 'react';
import { CheckIcon } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { TextField } from '../../components/ui/Field';
import { useAdminData } from '../../contexts/AdminDataContext';
export function Settings() {
  const {
    settings,
    updateSettings
  } = useAdminData();
  const [draft, setDraft] = useState(settings);
  const [saved, setSaved] = useState(false);
  const dirty = JSON.stringify(draft) !== JSON.stringify(settings);
  return <div className="px-5 py-7 md:px-8 md:py-10" data-id="element-562" data-mp="2tjt6rhy2ihwq">
      <p className="text-sm text-ink-muted" data-id="element-563" data-mp="2tj9kxq5ar9df">Virksomhed og standardpriser</p>
      <h1 className="mt-1 font-display text-[clamp(1.8rem,5vw,2.5rem)] font-bold leading-[1.05] tracking-tight text-ink" data-id="element-564" data-mp="2fkte7z7fpiva">
        Indstillinger
      </h1>

      <form className="mt-7 max-w-2xl space-y-5" onSubmit={event => {
      event.preventDefault();
      updateSettings(draft);
      setSaved(true);
      window.setTimeout(() => setSaved(false), 2500);
    }} data-id="element-565" data-mp="2kkxze2jaf1ru">
        <section className="rounded-card border border-line bg-white p-6" data-id="element-566" data-mp="2iu2j0xyuu55y">
          <h2 className="font-display text-lg font-bold tracking-tight text-ink" data-id="element-567" data-mp="2es7hbsd0hprn">Virksomhed</h2>
          <div className="mt-5 grid gap-5 sm:grid-cols-2" data-id="element-568" data-mp="2ss07nmkmm3z3">
            <TextField id="in-navn" label="Firmanavn" value={draft.companyName} onChange={event => setDraft({
            ...draft,
            companyName: event.target.value
          })} data-id="element-569" data-mp="2spe0ho1ndqhe" />
            <TextField id="in-cvr" label="CVR" value={draft.cvr} onChange={event => setDraft({
            ...draft,
            cvr: event.target.value
          })} data-id="element-570" data-mp="2xqtjlak9lmx5" />
            <TextField id="in-tlf" label="Telefon" type="tel" value={draft.phone} onChange={event => setDraft({
            ...draft,
            phone: event.target.value
          })} data-id="element-571" data-mp="36iddnjdyj8ls" />
            <TextField id="in-mail" label="E-mail" type="email" value={draft.email} onChange={event => setDraft({
            ...draft,
            email: event.target.value
          })} data-id="element-572" data-mp="3gicppq9l5h3e" />
          </div>
        </section>

        <section className="rounded-card border border-line bg-white p-6" data-id="element-573" data-mp="1crn9obztjf0">
          <h2 className="font-display text-lg font-bold tracking-tight text-ink" data-id="element-574" data-mp="63ht12obzoa8">Standardpriser</h2>
          <div className="mt-5 grid gap-5 sm:grid-cols-2" data-id="element-575" data-mp="b34icahfouze">
            <TextField id="in-timepris" label="Timepris (kr.)" inputMode="numeric" value={draft.hourlyRate} onChange={event => setDraft({
            ...draft,
            hourlyRate: event.target.value
          })} data-id="element-576" data-mp="b2l0etrsa6ld" />
            <TextField id="in-udkald" label="Udkaldsgebyr (kr.)" inputMode="numeric" value={draft.callOutFee} onChange={event => setDraft({
            ...draft,
            callOutFee: event.target.value
          })} data-id="element-577" data-mp="p1knhwznedff" />
          </div>
          <p className="mt-4 text-sm text-ink-muted" data-id="element-578" data-mp="2jazhqe7p746o">
            Bruges som forslag, når du opretter en ny sag. Du kan altid ændre prisen på den enkelte sag.
          </p>
        </section>

        <div className="flex flex-wrap items-center gap-4" data-id="element-579" data-mp="29k4xtghxcgoe">
          <Button type="submit" size="lg" disabled={!dirty} data-id="element-580" data-mp="29ik3nrziuzr2">
            Gem indstillinger
          </Button>
          {dirty && !saved && <p className="text-[15px] text-ink-muted" data-id="element-581" data-mp="32922ggt7qeyo">Der er ændringer, der ikke er gemt.</p>}
          {saved && <p role="status" className="flex items-center gap-2 text-[15px] text-ink" data-id="element-582" data-mp="2x9z9huqibz72">
              <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-accent-soft text-accent-deep" data-id="element-583" data-mp="2samo7efab06l">
                <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-584" data-mp="2nb1ficabbdgo" />
              </span>
              Indstillinger gemt.
            </p>}
        </div>
      </form>

      <p className="mt-8 max-w-2xl text-sm text-ink-muted" data-id="element-585" data-mp="1bweeikfm4lcd">
        Alle sager, kunder, noter, billeder og indstillinger gemmes automatisk i denne browser, så de også er
        der, næste gang du logger ind.
      </p>
    </div>;
}